const isValidEmail = /^[\w.+-]+@([\w-]+\.)+[\w-]{2,4}$/g;

const ValidateEmail = (value) => {
  if(value && value.match(isValidEmail)){
    return true;
  }else{
    return false;
  }
}

export default ValidateEmail;
